import { isFeatureEnabled } from 'owa-feature-flags';
import { getCurrentCulture } from 'owa-localize';
import { getGuid } from 'owa-guid';
import type { Dispatch } from 'redux';
import { runWithQoS, Feature, createDataActionFactory, getLogger, isConsumer } from '../../shared';

const getLokiModule = () => import(/* webpackChunkName: "OwaPeopleLoki"*/ 'owa-people-loki');

export const livePersonaCardInvalidateCachedPersonasCompletedAction = createDataActionFactory<
    string[],
    string[]
>('LivePersonaCardInvalidateCachedPersonasCompletedAction', Feature.LivePersonaCard);

export const initialize = (logger: (eventName: string, customData: {}) => void) => {
    const culture: string = getCurrentCulture();
    const useDogfood: boolean = isFeatureEnabled('peo-lokiDogfood');
    const clientCorrelationId = getGuid();

    logger('InitializeLoki', { clientCorrelationId });

    const customLogger = (eventName: string, customData: {}[]) => {
        logger(eventName, Object.assign({}, customData));
    };

    return getLokiModule().then(module =>
        module.initializeLoki({
            culture,
            isConsumer: isConsumer(),
            useDogfood,
            logger: customLogger,
            clientCorrelationId,
        })
    );
};

/**
 * Removes the given personaIds from Loki's ContactDataProvider cache and from the LPC cache (PersonaStore).
 * Also refetches data for the LPC current persona.
 * @param personaIds List of personaIds to invalidate.
 */
export const invalidateCachedContacts = (dispatch: Dispatch) => (
    personaIds: string[]
): Promise<void> => {
    const LPC: { invalidateCachedContacts: (olsPersonaIds: string[]) => Promise<void> } =
        window['LPC'];

    if (!LPC) {
        // LPC failed to load so we cannot do invalidate at this point
        getLogger().log('invalidateCachedContacts - LPC not available');
        return Promise.resolve();
    }

    return runWithQoS<void>({
        scenarioName: 'InvalidateCachedContacts',
        feature: Feature.LivePersonaCard,
        operation: LPC.invalidateCachedContacts(personaIds).then(
            () => {
                dispatch(
                    livePersonaCardInvalidateCachedPersonasCompletedAction.success(personaIds)
                );
            },
            error => {
                dispatch(livePersonaCardInvalidateCachedPersonasCompletedAction.error(personaIds));
                throw error;
            }
        ),
    });
};
export type { Action } from '../../shared';
export type { DataActionFactory } from '../../shared';
